import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { authApi } from '../store/auth/authApi';
import { userAPI } from '../store/user/userApi';
import { userDomAPI } from '../store/user/userDomApi';
import teamsSlice from '../store/brokers/partners/teams/teamsSlice';
import partnersSlice from '../store/brokers/partners/partners/partnersSlice';
import activitiesSlice from '../store/brokers/partners/activities/activititesSlice';
import historyChatsSlice from '../store/brokers/partners/history-chats/historyChatsSlice';
import userAccessSlice from '../store/brokers/partners/user-access-control/userAccessSlice';
import notificationsSlice from '../store/brokers/partners/notifications/notificationsSlice';
import chatsSlice from '../store/slices/chats.slice';
import { chatboxApi } from '../store/chatbox/chatboxApi';
import {executiveApi } from '../store/excecutive/executiveApi'; 
import chatsUISlice from '../store/brokers/partners/chats/ChatsUISlice';
import promptsSlice from '../store/brokers/configs/prompts/promptsSlice';
import modelsSlice from '../store/brokers/configs/models/modelsSlice';
import competitorsSlice from '../store/brokers/configs/competitors/competitorsSlice';
import setupSlice from '../store/brokers/partners/chats/SetupSlice';
import sourcesSlice from '../store/brokers/configs/sources/sourcesSlice';
import { profileApi } from '../store/profile/profileApi';


export const store = configureStore({
    reducer: {
        [userAPI.reducerPath]: userAPI.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [userDomAPI.reducerPath]: userDomAPI.reducer,
        [chatboxApi.reducerPath]: chatboxApi.reducer,
		[executiveApi.reducerPath]: executiveApi.reducer,
        [profileApi.reducerPath]: profileApi.reducer,
        userAccess: userAccessSlice,
        partners: partnersSlice,
        history: historyChatsSlice,
        teams: teamsSlice,
        notifications: notificationsSlice,
        activities: activitiesSlice,
        chats: chatsSlice,
        chatUi: chatsUISlice,
        prompts: promptsSlice,
        models: modelsSlice,
        competitors: competitorsSlice,
        setup: setupSlice,
        sources: sourcesSlice
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            userAPI.middleware,
            authApi.middleware,
            userDomAPI.middleware,
            chatboxApi.middleware,
			executiveApi.middleware,
            profileApi.middleware
        ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
